/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sold: NonNullable<unknown> }} Ticketssold1Inputs */

const en_ticketssold1 = /** @type {(inputs: Ticketssold1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sold} sold`)
};

const de_ticketssold1 = /** @type {(inputs: Ticketssold1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sold} verkauft`)
};

/**
* | output |
* | --- |
* | "{sold} sold" |
*
* @param {Ticketssold1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketssold1 = /** @type {((inputs: Ticketssold1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketssold1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketssold1(inputs)
	return de_ticketssold1(inputs)
});
export { ticketssold1 as "ticketsSold" }